import { PermissionMatrixActions } from './partials/matrix'
import { PermissionsRoleActions } from './partials/role'
import { ResourceActions } from './partials/resources'
import { TeamActions } from './partials/team'

export const PermissionActions = {
  ...PermissionMatrixActions,
  ...PermissionsRoleActions,
  ...ResourceActions,
  ...TeamActions,
}
